<template>
  <div
    :style="{
      backgroundColor: isDarkTheme ? mainBgColor : '#eeeeee',
      minHeight: '100vh',
      height: 'auto',
      paddingBottom: '10px'
    }"
  >
    <header-o :model="headerData"></header-o>
    <div
      class=""
      style="margin-right: 15px; margin-left: 15px; margin-top: -170px"
    >
      <div>
        <div
          :style="{
            backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
            borderRadius: '10px'
          }"
          class="past-history-section"
        >
          <div
            :style="{
              backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
              borderRadius: '10px'
            }"
            class="text-center myfontstyle"
          >
            <div
              :style="{
                backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
                paddingTop: '20px',
                borderRadius: '10px'
              }"
              class="offer-card bg-light padding-5 pos-rel box-shadow"
            >
              <img
                class="medium-icon margin-right-5 margin-bottom-10"
                src="@/assets/Leaderboard Assest/Leaderboard.svg"
              />
              <div
                style="margin-top: 10px"
                class="margin-bottom-10 padding-vertical-10 font-extra-bold text-large past-history-title"
              >
                <span style="font-size: 20px; font-weight: 500">{{
                  bonanza.title
                }}</span>
              </div>
              <div
                class="margin-bottom-20 padding-vertical-10 desc"
                style="display: block; text-align: center; font-size: 14px"
              >
                {{ bonanza.description }}
              </div>

              <div class="align-hor center-ver center-hor">
                <img style="width: 100%" :src="bonanza.banner_url" />
              </div>
            </div>

            <div
              :style="{
                backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff'
              }"
              class="history-table"
            >
              <div class="title past-history-title" style="padding-top: 20px">
                <span
                  style="
                    font-weight: 400 !important;
                    font-size: 18px !important;
                  "
                  >{{ bonanza.prizes_title }}</span
                >
              </div>

              <div
                class="table-responsive past-history-title"
                style="box-sizing: border-box"
              >
                <table class="table table-borderless">
                  <thead>
                    <tr
                      :style="{
                        backgroundColor: isDarkTheme
                          ? offersCardBgColor
                          : '#ffffff',
                        padding: ' 5px 10px',
                        borderBottom: '1px solid #BEBEBE'
                      }"
                    >
                      <th style="padding: 10px 0px">
                        <img
                          src="@/assets/Leaderboard Assest/Rank.svg"
                          class="small-icon mx-2"
                          style="margin-left: 0.05rem !important"
                        />
                        <span
                          style="
                            padding-top: 2px;
                            font-size: 13px;
                            font-weight: 600;
                            margin-top: 3px;
                          "
                          >Rank</span
                        >
                      </th>
                      <th style="padding: 10px 0px">
                        <img
                          :src="bonanza.currency_icon"
                          class="small-icon mx-2"
                        />
                        <span
                          style="
                            padding-top: 2px;
                            font-size: 13px;
                            font-weight: 600;
                            margin-top: 3px;
                          "
                          >{{ bonanza.currency_label }}</span
                        >
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="price in bonanza.prizes"
                      :key="price.from_rank"
                      :style="{
                        backgroundColor: isDarkTheme
                          ? offersCardBgColor
                          : '#ffffff',
                        padding: '5px 10px',
                        borderBottom: '1px solid #BEBEBE'
                      }"
                    >
                      <td
                        v-if="price.from_rank != price.to_rank"
                        style="font-size: 14px; color: #544E4E;"
                      >
                        {{ price.from_rank }} - {{ price.to_rank }}
                      </td>
                      <td v-else style="font-size: 14px; color: #544E4E;">
                        {{ price.to_rank }}
                      </td>
                      <td
                        v-if="price.from_prize != price.to_prize"
                        style="font-size: 14px; font-weight: 600; color: #323232;"
                      >
                        <!-- {{ price.from_prize }} - {{ price.to_prize }} -->
                        {{
                          price.from_prize !== 0 ? price.from_prize : "Up to"
                        }}
                        {{ price.from_prize !== 0 ? "-" : "" }}
                        {{ price.to_prize }}
                      </td>
                      <td v-else style="font-size: 14px; color: #323232;">
                        {{ price.to_prize }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!-- Table Start -->
          <div
            :style="{
              backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff'
            }"
            class="history-table"
            style="padding: 0px !important"
          >
            <div
              style="padding: 0px !important; margin-top: 20px !important"
              class="title past-history-title"
            >
              <span
                class="myfontstyle"
                style="font-weight: 400 !important; font-size: 18px !important"
                >{{ bonanza.events_title }}</span
              >
            </div>

            <div
              class="table-responsive past-history-title"
              style="box-sizing: border-box"
            >
              <table class="table table-borderless">
                <thead>
                  <tr
                    :style="{
                      backgroundColor: isDarkTheme
                        ? offersCardBgColor
                        : '#ffffff',
                      padding: '5px 10px',
                      borderBottom: '1px solid #BEBEBE'
                    }"
                  >
                    <th style="padding: 10px 0px">
                      <img
                        src="@/assets/Leaderboard Assest/Challanges.svg"
                        class="small-icon mx-2"
                        style="margin-left: 0.05rem !important"
                      /><span style="font-size: 13px; font-weight: 600"
                        >Challenges</span
                      >
                    </th>
                    <th style="padding: 10px 0px">
                      <img
                        src="@/assets/Leaderboard Assest/XP.svg"
                        class="small-icon mx-2"
                      /><span style="font-size: 13px; font-weight: 600">{{
                        bonanza.score_label
                      }}</span>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="event in bonanza.events"
                    :key="event.label"
                    :style="{
                      backgroundColor: isDarkTheme
                        ? offersCardBgColor
                        : '#ffffff',
                      padding: '5px 10px',
                      borderBottom: '1px solid #BEBEBE'
                    }"
                  >
                    <td style="font-size: 14px; color: #544E4E;">
                      {{ event.label }}
                    </td>
                    <td
                      class="name"
                      style="font-size: 14px; font-weight: 600; color: #323232;"
                    >
                      {{ event.score }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            :style="{
              backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff',
              padding: '10px'
            }"
            style="
              border-bottom-left-radius: 10px;
              border-bottom-right-radius: 10px;
            "
            class="past-history-title text-center myfontstyle"
          >
            <div
              :style="{
                backgroundColor: isDarkTheme ? offersCardBgColor : '#ffffff'
              }"
              class="offer-card bg-light radius-5 padding-10 margin-bottom-10 pos-rel box-shadow"
            >
              <div
                class="margin-bottom-10 padding-vertical-10 font-extra-bold text-large"
                style="font-size: 14px; height: 14px; color: #585957"
              >
                Contest LeaderBoard
              </div>
              <hr />
              <div
                style="font-weight: 700; color:  #585957;"
                class="margin-bottom-20 padding-vertical-10 desc"
                v-if="bonanza.user_data == null || bonanza.user_data == ''"
              >
                You Have not Participated Yet
              </div>
              <div
                class="margin-bottom-20 padding-vertical-10 desc"
                style="
                  display: flex;
                  justify-content: space-between;
                  margin: 0px;
                  padding: 0px;
                "
                v-else
              >
                <span
                  ><p
                    style="
                      font-family: 'Montserrat', sans-serif;
                      font-weight: 700;
                      font-size: 15px;
                      color: #585957;
                    "
                  >
                    Your Rank #{{
                      bonanza.user_data ? bonanza.user_data.rank : ""
                    }}
                  </p></span
                >
                <span
                  ><p
                    :style="{
                      fontFamily: 'Montserrat, sans-serif',
                      fontWeight: '600',
                      color: isDarkTheme ? topBgColor : bgTheme,
                      fontSize: '15px'
                    }"
                  >
                    {{ bonanza.user_data ? bonanza.user_data.score : "" }}
                    {{ bonanza.score_label }}
                  </p></span
                >
              </div>
              <hr />
              <div
                class="margin-bottom-20 padding-vertical-10 desc pointer"
                :style="{
                  background: isDarkTheme ? buttonBGColor : bgTheme,
                  color: isDarkTheme ? headingTextColor : '#ffffff'
                }"
                style="border-radius: 5px; margin-block: auto; padding: 10px"
                @click="redirectTo('leaderboard/' + bonanza.id)"
              >
                <span
                  :style="{
                    color: isDarkTheme ? headingTextColor : '#ffffff',
                    fontWeight: '600'
                  }"
                  >View Full LeaderBoard</span
                >
              </div>
            </div>
          </div>
          <!-- Table End -->
        </div>
      </div>
    </div>
    <leaderboardPopUp
      v-if="isShowLeaderboardModal"
      :model="leaderboardRules"
    ></leaderboardPopUp>
  </div>
</template>
<script>
import { globals } from "@/mixins/globals";
import axios from "axios";
import OverlapHeader from "@/components/overlapped-header";
import leaderboardPopUp from "@/components/leaderboardPopup";

export default {
  mixins: [globals],
  components: {
    "header-o": OverlapHeader,
    leaderboardPopUp: leaderboardPopUp
  },
  data() {
    return {
      headerData: {
        onlyHeader: true,
        isLeaderBoard: true,
        leaderBoardId: this.$route.params.id
      },
      isCheckIn: false,
      is_shimmer: true,
      leaderboardRules: {
        rules: ""
      },
      bonanza: {}
    };
  },
  computed: {
    topBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.topBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.topBgColor;
      }
      return null; // fallback
    },
    isDarkTheme() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null;
    },
    buttonBGColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.buttonBGColor
      ) {
        return this.$store.state.sdkEvent.themeColors.buttonBGColor;
      }
      return null;
    },
    headingTextColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.headingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.headingTextColor;
      }
      return null;
    },
    mainBgColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.mainBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.mainBgColor;
      }
      return null;
    },
    offersCardBgColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.offersCardBgColor;
      }
      return null;
    },
    showShimmer: function() {
      return this.is_shimmer;
    }
  },
  beforeMount() {
    var self = this;
    if (window.addEventListener) {
      window.addEventListener("message", self.handleSDKMessage, false);
    } else {
      window.attachEvent("onmessage", self.handleSDKMessage);
    }
    this.loadDataFromCookie();
  },
  methods: {
    getLeaderBoardContest() {
      const id = this.$route.params.id;
      if (id) {
        axios.all([this.getLeaderBoardInfo(id)]).then(
          axios.spread(resp => {
            if (resp.status == 200) {
              var data = resp.data;
              this.$store.state.headTitle = data.title;
              this.bonanza = data.bonanza;
              this.leaderboardRules.rules = this.bonanza.rules;
            }
          })
        );
      } else {
        axios.all([this.getLeaderBoardInfo()]).then(
          axios.spread(resp => {
            if (resp.status == 200) {
              var data = resp.data;
              this.$store.state.headTitle = data.title;
              this.bonanza = data.bonanza;
              this.leaderboardRules.rules = this.bonanza.rules;
            }
          })
        );
      }
    }
  },
  created() {
    var store_state = this.$store.state;
    store_state.showHeader = false;
    store_state.showWallet = false;
    store_state.showHistory = false;
    store_state.user.headerBalance.show = false;
    store_state.headTitle = "";
    this.getLeaderBoardContest();
    document.documentElement.style.setProperty(
      "--bg-color",
      this.$store.state.bg_theme
    );
    document.documentElement.style.setProperty(
      "--bg-light-color",
      this.$store.state.bg_theme + "59"
    );
  }
};
</script>
<style scoped>
@import "../../assets/quiz-styles/quiz-styles.css";
@import "../../assets/quiz-styles/bootstrap.css";
@import "../../assets/fonts/quiz-fonts/fonts.css";
.currency-type {
  position: absolute;
  top: 10px;
  right: 10px;
}
.currency-type.dummy {
  right: 30px;
}
th,
tr {
  display: flex;
  justify-content: space-between;
  padding: 10px 0px;
}

.past-history-title span {
  font-family: "Montserrat-bold", sans-serif;
  font-size: 16px;
  line-height: 19px;
  color: #373535;
  font-weight: 200;
}
</style>
